import cadex from '@cadexchanger/web-toolkit'
import { Typography } from '@material-ui/core'
import { ZoomOutMapOutlined } from '@material-ui/icons'
import { ActionIconButton } from 'components/Layout/ActionIconButton'

type FitAllProps = {
  viewPort: cadex.ModelPrs_ViewPort
}

export const FitAll = ({ viewPort }: FitAllProps) => {
  return (
    <ActionIconButton
      style={{ width: '70px', height: '70px' }}
      onClick={() => viewPort.fitAll()}
    >
      <ZoomOutMapOutlined />
      <Typography variant="caption">fit all</Typography>
    </ActionIconButton>
  )
}
